import { z } from 'zod';

export const optionalNumberFromQuery = z.preprocess((v: unknown) => {
    if (v === undefined || v === null || v === '') return undefined;

    if (typeof v === 'number') return Number.isFinite(v) ? v : v;

    if (typeof v === 'string') {
        const n = Number(v);
        return Number.isFinite(n) ? n : v;
    }

    return v;
}, z.number().finite().optional());
